import React, { useEffect, useRef, useState } from 'react';
const Grid = ({ cells, length, height }) => {
    const divRef = useRef(null);
    const [unit, setUnit] = useState(0);
    useEffect(() => {
        if (divRef.current) {
            const rect = divRef.current.getBoundingClientRect();
            setUnit(Math.floor(Math.min((rect.width - 10) / length, (rect.height - 10) / height)));
        }
    }, [length, height]);
    return (React.createElement("div", { ref: divRef, id: "crossword-grid", style: {
            height: '100%',
            width: '100%',
            padding: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        } }, cells.map((row, i) => (React.createElement("div", { key: i, style: {
            display: 'flex',
            flexDirection: 'row',
            padding: 0,
            margin: 0,
        } }, row.map((cell, j) => cell.type === 'blank' ? (React.createElement("div", { key: j, className: i !== 0 &&
            i !== height - 1 &&
            j !== 0 &&
            j !== length - 1 &&
            cells[i + 1][j].type === 'word' &&
            cells[i - 1][j].type === 'word' &&
            cells[i][j + 1].type === 'word' &&
            cells[i][j - 1].type === 'word'
            ? 'crossword-cell-filled'
            : 'crossword-cell-empty', style: {
            width: unit,
            height: unit,
        } })) : (React.createElement("div", { key: j, className: "crossword-cell-input", style: { width: unit, height: unit } },
        React.createElement("fieldset", { key: j, style: {
                border: 'none',
                position: 'relative',
                margin: 0,
                padding: 0,
                height: '100%',
                width: '100%',
            } },
            React.createElement("legend", { style: {
                    position: 'absolute',
                    fontSize: unit / 4,
                    top: '2px',
                    left: '2px',
                    margin: 0,
                    padding: 0,
                    zIndex: '999',
                } }, cell.hintNumber),
            React.createElement("div", { className: "crossword-cell", style: {
                    width: unit,
                    height: unit,
                    fontSize: unit / 2,
                } },
                React.createElement("label", { id: i + '-' + j, key: j }, cell.letter)))))))))));
};
export { Grid };
